import * as Api from "../proto/promotion/service";
import { AuthGrpcInterceptor } from "./grpc-interceptor.service";
import { endpointBaseGRPC } from "src/main";
import { inject, Injectable } from "@angular/core";
import { PromotionParams } from "../models/promotion";

@Injectable({
  providedIn: "root",
})
export class GrpcPromotionService {
  // Injeta o interceptor como singleton para evitar múltiplas instâncias
  // com estados de refresh independentes (race condition)
  private authInterceptor = inject(AuthGrpcInterceptor);

  private client: Api.promotion.v1.PromotionServiceClient;

  constructor() {
    this.client = new Api.promotion.v1.PromotionServiceClient(endpointBaseGRPC, undefined, {
      unaryInterceptors: [this.authInterceptor],
    });
  }

  getPromotions(params: PromotionParams = {}) {
    const request = new Api.promotion.v1.SearchPromotionsRequest(params);
    return this.client.SearchPromotions(request, {});
  }

  getPromotionById(promotionId: string) {
    const request = new Api.promotion.v1.GetPromotionByIDRequest({ promotionId });
    return this.client.GetPromotionByID(request, {});
  }

  getPromotionFlavors() {
    const request = new Api.promotion.v1.GetSearchFilterPromotionsRequest();
    return this.client.GetSearchFilterPromotions(request, {});
  }
}
